const STIRRING = 1;

import gpio from "gpio";
import Device from "../device.js";


class Stirring extends Device {
  constructor() {
    super();
    
    this.id = "Stirring";
    this.status = "uninitalized";
    this.__rpm = 0;
  }
  initialize() {
    return( new Promise(function(resolve, reject) {
      this.status = "Failed";

      if (gpio.pwm[STIRRING].exported()) gpio.pwm[STIRRING].unexport();
      gpio.pwm[STIRRING].export();

      setTimeout(function() {
        //gpio.pwm[STIRRING].enable();

        if (gpio.pwm[STIRRING].duty_cycle != 0)
          gpio.pwm[STIRRING].duty_cycle = 0;
        gpio.pwm[STIRRING].period = 10000;
        gpio.pwm[STIRRING].duty_cycle = 0;

        gpio.pwm[STIRRING].disable();
        gpio.pwm[STIRRING].enable();

        this.__rpm = 0;

        this.usbProductName = "jmc_mcac708";
        this.usbSerialNumber = "1";                 
        this.name = "stirring";
                
        this.status = "Ok";
        resolve(true);
      }.bind(this), 1000);
    }.bind(this)) );
  }
  set rpm(rpm) {
    if (isNaN(rpm)) throw "RPM must be a number";
    if (rpm < 0) throw "RPM must be between 0..2000";
    if (rpm > 2000) throw "RPM must be between 0..2000";

    /* RPM to RPS */
    var rps = rpm / 60;

    /* 0.25 RPM = 1kHz ??? */
    /* 1 RPM = 4kHz ??? */
    var f = rps * 1000 * 4;
    var period = f==0 ? 0 : (1 / f);
    period *= 1000000000; /* in ns */
    /* Maximum pulse input frequency 300K */
    /* period = 1 / frequency */
    gpio.pwm[STIRRING].duty_cycle = 0;
    gpio.pwm[STIRRING].disable();
    /* period can not be set to 0 */
    if (rps != 0) {
      gpio.pwm[STIRRING].period = Math.round(period);
      /* Value is in nanoseconds and is the sum of the active and inactive time of the PWM.*/
      gpio.pwm[STIRRING].duty_cycle = Math.round(period/2);
      gpio.pwm[STIRRING].enable();
    }
    this.__rpm = rpm;
  }
  get rpm() {
    return(this.__rpm);
  }
  update() {
    return( new Promise(function(resolve, reject) {
      resolve(true);
    }.bind(this)) );
  }
  async RM_setRPM(value) {
    this.rpm = value;    
  }  
  logData(logData) {
    logData.append(`${this.name}`, this.rpm);    
  }  
  toJSON() {
    try {
      return({
        name: this.name,            
        usbProductName: this.usbProductName,
        usbSerialNumber: this.usbSerialNumber,      
        status: this.status,      
        id: this.id,      
        rpm: Math.round(this.rpm),
        value: Math.round(this.rpm),
        sp: Math.round(this.rpm),
        pv: Math.round(this.rpm)
      })
    } catch(e) {
      return({
        id: this.id,
        status: "Failed",
        rpm: "-"
      })
    }
  }
}

export default Stirring;